import { useRoutes } from 'react-router-dom';
import { TweaksPanel } from '@/features/tweaks/TweaksPanel';
import { routes } from './routes';

function RoutedContent() {
  return useRoutes(routes);
}

export function App() {
  return (
    <>
      <RoutedContent />
      <TweaksPanel />
    </>
  );
}
